import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => {
  return (
    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "60px 20px",
      }}
    >
      <div>
        <h1
          style={{
            fontSize: "120px",
            fontWeight: "700",
            lineHeight: "1",
            margin: 0,
          }}
        >
          404
        </h1>

        <h2 className="mt-3">Page Not Found</h2>

        <p className="text-muted mt-3">
          Sorry, the page you are looking for doesn't exist or may have been
          moved.
        </p>

        <Link to="/" className="btn btn-primary mt-3 home-btn">
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;